'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/seo.ts
var SEO_QUERY = `
title
description
keywords
image {${IMAGE_QUERY}}
noindex
`;

export {
  SEO_QUERY
};
//# sourceMappingURL=chunk-J54FE6N4.mjs.map